var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatNotConnectedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 156.547,
    viewBox: "0 0 140 156.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live-chat-not-connected",
    transform: "translate(-110 -179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(-706.036 18.964)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 70,
    cy: 70,
    r: 70,
    transform: "translate(816.036 160.036)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline",
    d: "M105.08,64h-48.2A8.9,8.9,0,0,0,48,72.879v30.443a8.9,8.9,0,0,0,8.879,8.879h6.342v12.684l14.86-12.39a1.269,1.269,0,0,1,.813-.295H105.08a8.9,8.9,0,0,0,8.879-8.879V72.879A8.9,8.9,0,0,0,105.08,64Z",
    transform: "translate(805.056 139.095)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    transform: "translate(1237.058 11044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M141.413,301.44l-62.61.022a8.682,8.682,0,0,1-7.54-13.049l31.285-56.953a8.7,8.7,0,0,1,15.07-.005l31.329,56.938a8.7,8.7,0,0,1-7.535,13.047h0Zm-70.541-8.677c0,1.36,6.909-1.571,7.624-.332,1.432,2.478-2.556,8.246.306,8.245,0,0,68.034-1.5,69.464-3.982a7.835,7.835,0,0,0,0-7.916l-31.329-56.938a7.832,7.832,0,0,0-6.852-3.948c-2.86,0-39.21,63.51-39.21,64.87h0Z",
    transform: "translate(-1165.236 -11009.915)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(-1065.548 -10778.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M28.663,0A28.663,28.663,0,1,1,0,28.663,28.663,28.663,0,0,1,28.663,0Z",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442",
    transform: "translate(19.132 9.278)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 2.632,
    cy: 2.632,
    r: 2.632,
    transform: "translate(6.905 31.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M203.73,263.874c-.242,1.606.191,1.943.194,8.868s1.439,16.211-.185,16.211-2.219-19.162-7.86-20.858c-6.632-1.994,8.633-9.421,7.851-4.221Z",
    transform: "translate(-194.205 -262.059)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M73.264,296.342l-2.59,5.472A40.179,40.179,0,0,1,82.586,296.6a40.146,40.146,0,0,1-10.713-7.371l1.489,5.781c-17.463-3.557-30-16.953-30.008-32.3l-.631-.217c.006,16.029,12.372,30.219,30.54,33.85Z",
    transform: "translate(-1148.618 -11031.406)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatNotConnectedIcon);
export default __webpack_public_path__ + "static/media/live-chat-not-connected-icon.19ab16636f6cb9134b9ab0304c176217.svg";
export { ForwardRef as ReactComponent };